import React from 'react';
import Input from 'src/components/Input/Input';
import { CardType } from 'src/pages/SubscriptionPage/PaymentMethod/AddPaymentMethodPopup/SplitElements';

export const PaymentMethodDetails = ({ paymentItem = {} }: { paymentItem?: any }) => {
  return (
    <div className="w-full">
      <Input
        className="placeholder:!text-base placeholder:!font-medium !rounded-sm-5 border-[#B8C1C666]"
        labelClassName="text-xs text-[#B8C1C6] mt-2"
        type={'text'}
        readonly
        label={paymentItem?.card_type === CardType[0] ? 'Company name' : 'Card holder name'}
        value={paymentItem.billing_details?.name || ''}
        isValid
      />
      <Input
        className="placeholder:!text-base placeholder:!font-medium !rounded-sm-5 border-[#B8C1C666]"
        labelClassName="text-xs text-[#B8C1C6] mt-2"
        type={'text'}
        label={'Billing address'}
        value={paymentItem.billing_details?.address?.line1 || ''}
        readonly
        isValid
      />
      <div className="flex pt-1 gap-1">
        <div className="w-full">
          <Input
            className="placeholder:!text-base placeholder:!font-medium !rounded-sm-5 border-[#B8C1C666]"
            labelClassName="text-xs text-green_450"
            type={'text'}
            label="Country"
            value={paymentItem.billing_details?.address?.country || ''}
            readonly
            isValid
          />
        </div>
        <div className="w-full">
          <Input
            className="placeholder:!text-base placeholder:!font-medium !rounded-sm-5 border-[#B8C1C666]"
            labelClassName="text-xs text-green_450"
            type={'text'}
            label="State"
            value={paymentItem.billing_details?.address?.state || ''}
            readonly
            isValid
          />
        </div>
      </div>
      <div className="flex pt-1 gap-1">
        <div className="w-full">
          <Input
            className="placeholder:!text-base placeholder:!font-medium !rounded-sm-5 border-[#B8C1C666]"
            labelClassName="text-xs text-green_450"
            type={'text'}
            label="City"
            value={paymentItem.billing_details?.address?.city || ''}
            isValid
            readonly
          />
        </div>
        <div className="w-full">
          <Input
            className="placeholder:!text-base placeholder:!font-medium !rounded-sm-5 border-[#B8C1C666]"
            labelClassName="text-xs text-green_450"
            type={'text'}
            label="Zip code"
            value={paymentItem.billing_details?.address?.postal_code || ''}
            readonly
            isValid
          />
        </div>
      </div>
      {paymentItem?.card_type === CardType[0] && (
        <Input
          labelClassName="text-xs text-[#B8C1C6] mt-2"
          className={'!rounded-sm-5'}
          type={'text'}
          label={'Tax ID'}
          value={paymentItem.tax_id || paymentItem.tax_id_value || ''}
          readonly
          isValid
        />
      )}
    </div>
  );
};
